module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "c3"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("CHAPTER III")]), _vm._v(" "), _c('br', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('span', {
    staticClass: "h2line"
  }, [_vm._v("ON TRACK OF A DEAL")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What’s this?” asked the city editor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That story of amateur night,” replied Larry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, yes, I’d forgotten all about it. I’m glad\nyou have the copy in early, as I want you to make\na quick trip out of town.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Any more floods?” asked Larry, thinking of\nthe big one he had helped cover when he was\na copy boy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Not this time; this is only to take a run over\nto New Jersey, to a little town called Cranford.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What’s the matter out there?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I want you to see Professor Allen. He is\nto deliver a lecture at the dinner of the Engineers’\nClub to-night, and he has promised a copy\nof his remarks in advance.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry was soon on his way, crossing the Hudson\nRiver on the ferry to the New Jersey side,\nwhere he took a train for Cranford. He found\nProfessor Allen’s house without much trouble,\nand inquired for the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I don’t believe you can see him,” replied the\ngirl who answered the door.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Why not; isn’t he at home?” asked Larry.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_20",
      "title": "20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well, he is and he isn’t,” replied the servant.\n“You see he’s out in his laboratory making experiments,\nwhich is what he’s most always up to,\nand he hasn’t been in to his meals for a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hasn’t he eaten for a week?” asked Larry, in\nsome surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, bless your heart, of course he’s eaten,\nbut he will not come to the table. His wife has\nto go out to the laboratory with a plate of victuals\nand a cup of coffee, and fairly feed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What’s the trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, you see he’s working on a new invention.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What sort?” asked Larry, thinking he might\nget a story out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Don’t ask me,” cried the servant, with a\nlaugh, for she evidently took Larry for some boy\non an errand. “It’s all about wheels and levers\nand steam and electricity. As near as I can get\nat, it’s a plan to make an automobile out of a\ntea kettle.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Don’t you suppose I could see the professor?”\nasked the young reporter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well, you can try,” said the girl. “The laboratory\nis that small white building down at the\nfar end of the yard. Go down there, and walk\nright in. If you knock he’ll never answer. Mrs.\nAllen has just fed him his breakfast, and perhaps\nhe’ll talk to you a little.”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_21",
      "title": "21"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry decided this was the only way of securing\nwhat he wanted, so he made his way to the\nlaboratory, and, remembering the injunction,\nentered the door and walked in.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He found himself in a large room, fairly filled\nwith machinery and appliances of all kinds.\nOverhead there were shafts and pulleys, while\nall about the sides were benches, lathes, wheels,\nlevers, handles, and springs of various sorts.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Down in one corner was an elderly gentleman,\nin rather an old and ragged suit, at work over\na bench. He did not look up as Larry entered,\nbut called out:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Come here and give me a hand with this. I’m\nin a hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry looked around to see if the professor\ncould be speaking to anyone else, but, finding\nthat he was the only one in the room besides the\nscientist, the lad concluded he was the one addressed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hurry, please,” added Mr. Allen, looking\nstraight at Larry. “I am in the midst of an important\nexperiment.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Thereupon Larry went to the bench. Mr.\nAllen was holding one end of a long steel tube\nfrom which radiated several smaller tubes of\nglass. At one end of the steel tube was a rubber\npipe which was attached to a gas jet, and at the\nother end of the tube there was another pipe\nwhich was fastened to a water faucet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Turn on the gas a little more, and then help\nme hold this tube,” spoke the scientist. “I am\ngenerating steam.”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_22",
      "title": "22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He spoke as though it was the most natural\nthing in the world for Larry to be there, and give\nhim assistance. Larry recognized that Mr. Allen\nwas too much absorbed in his experiment to care\nwho helped him, so the boy lent a hand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry turned the gas on, and then grasped one\nend of the tube. Mr. Allen held the other. There\nwas a curious rumbling sound, followed by a\nroar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Duck! She’s going to explode again!” cried\nMr. Allen, dropping his end of the tube, and\ncrawling under a table. Larry lost no time in\nfollowing his example. The next instant there\nwas a loud report, and pieces of the tube and\nrubber hose were flying in all directions.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“It’s all over, you can come out now,” remarked\nthe scientist, in a quiet voice, a few seconds\nlater.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Does it often act that way?” inquired Larry,\nearnestly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That’s the twenty-seventh time it has blown\nup,” replied the professor. “I guess the glass is\nnot strong enough for the steam.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Isn’t it dangerous?” ventured Larry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Dangerous? Of course it is! That’s what\nI expect in this business. But I have another\ntube here, and we’ll try it again. Just take your\ncoat off, and help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I’m afraid I haven’t time,” replied the reporter.\n“I’m from the New York "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Daily Leader")]), _vm._v(".\nI came to get a copy of your speech.”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_23",
      "title": "23"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What’s that?” inquired Mr. Allen, sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry repeated his statement more fully.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Bless my soul!” exclaimed the professor. “I\ntook you for my assistant’s son. He often helps\nme. I didn’t get a good look at you, I was so\nbusy thinking about this steam problem. I hope\nyou were not hurt when the explosion came.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Not a bit,” replied Larry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Father! Father! Are you injured?” cried\na voice, and a woman, much excited, hurried\ninto the laboratory.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Not a bit, my dear, not a bit,” replied the professor,\nas he brushed the dust from his clothes.\n“Another tube blew up, that’s all,” and he seemed\nas cheerful as though the experiment had succeeded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, those horrible, dangerous steam tubes!”\nexclaimed the lady. Then she saw Larry, and,\nobserving he was a stranger, was about to withdraw.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“This is a reporter from the New York\n"), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Leader")]), _vm._v(",” explained the scientist. “He has come\nfor a copy of my speech, and it’s a good thing he\ndid. I had forgotten all about delivering it to-night.\nI guess I’ll go in the house, and get\nready. Come with me,” he added to Larry, “and\nI’ll get the copy for you.”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_24",
      "title": "24"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Thank goodness something happened to make\nhim come back to civilization,” remarked the\nlady to Larry, as they walked toward the house.\n“He has slept in that laboratory, and taken his\nmeals there ever since he started on this latest\nidea. It’s a good thing you came along, and\nawakened him to some realization that there’s\nsomething in this world besides those terrible\nsteam tubes.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Perhaps the explosion did,” ventured Larry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That? It would take more than an explosion,”\nthe lady, who was Mr. Allen’s daughter,\nreplied. “He’s used to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry went into the house, where, after some\nsearch, Mr. Allen found a copy of his remarks,\nwhich he gave to the young reporter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Come out and see me again some day,” the\nscientist invited Larry. “We’ll try that experiment\nagain.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I’m afraid once is enough for me,” said Larry,\nwith a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He reached his office shortly after noon, and,\nhanding in the copy of the speech, which had\nbeen gotten in advance, so as to be set up ready\nfor the next day’s paper. Then he reported at\nthe desk, announcing to Mr. Emberg that he was\nready for another assignment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Take a run down to City Hall,” said the city\neditor. “Mr. Newton is covering it to-day, but\nhe is busy on a story, and he telephoned in he had\nno time to make all the rounds of the offices.\nJust see if there are any routine matters he had\nto overlook.”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_25",
      "title": "25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It was the first time Larry had ever been assigned\nto the municipal building alone. He was\nfamiliar with most of the offices and knew some\nof the officials by sight, as Mr. Newton had frequently\ntaken him around to “learn him the\nropes,” as he said. So Larry felt not a little\nelated, and began to dream of the time when he\nmight have important assignments, such as looking\nafter city matters and politics, matters to\nwhich New York papers pay great attention.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Larry went into several offices at the hall, and\nfound there was no news. It was rather a dull\nday along municipal and political lines, and there\nwere few reporters around the building. Larry\nknew some of them, who nodded to him in a\nfriendly way, and asked him whether there was\n“anything new,” a reporter’s manner of inquiring\nfor news.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("As Larry had nothing he said so, it being a\nsort of unwritten law among newspaper men not\nto beat each other on routine assignments, unless\nthere was some special story they were after.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It was almost closing hour at the hall, and\nwithin a few minutes of the time the "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Leader’s")]), _vm._v("\nlast edition went to press, that Larry entered the\nanteroom of the City Comptroller’s office. He\nhardly expected there would be any news, and\nhe knew if there was it was almost too late for\nthat day. However, he was tired, and, as there\nwere comfortable chairs in the office, he resolved\nto have a few minutes’ rest, while waiting to\nsee the official or the chief clerk to ask if there\nwas anything new.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_26",
      "title": "26"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It was while sitting there, with his chair tilted\nback against a thin partition, that Larry overheard\nvoices in somewhat loud conversation. At\nfirst he paid little attention to the matter. But\nwhen one of the voices became quite loud he\ncould not help hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I tell you I’ve got the whole plan outlined,\nand we can all make big money by it,” someone\nremarked. “I know the lay of the land. It’s\nup in the Bronx.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("At that Larry began to take some notice, as\nhe remembered he and his mother were interested\nin some Bronx property.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“The deal is going through, then?” asked another\nman.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Now Larry had no intention of eavesdropping,\nand, if he had thought the conversation was of a\nprivate nature, he would have moved away. But\nit seemed the men had nothing to conceal, for\nthey talked loudly. They were probably unaware\nthat a transom over the door of the room where\nthey were, was open.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What makes you so sure the land will be valuable?”\nasked another voice.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Because I know it,” came the answer from\nthe one who had first spoken. “There’s going\nto be an ordinance introduced in the Common\nCouncil soon. Now all we have to do is to buy\nup all the lots——” What followed was in a\nlow tone, and Larry could not hear. Then the\nvoice went on: “It’s a great game, for it will\ntake our votes to pass the ordinance, see?”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_27",
      "title": "27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Won’t there be some danger?” asked someone.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Not a bit. There’s only one hitch. I’ve been\nlooking the thing up, and I find that the most\nvaluable strip of land in the whole tract is owned\nby some man up New York State.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Who is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Something like Pexter or Wexter,” was the\nreply, whereat Larry felt his heart beating\nstrongly. Suppose it should happen to be the\nland for which his mother held the deed?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Can we put the deal through?” several asked\nof the man who was doing the most talking.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Sure we can,” was the answer. “Alderman——”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hush! Not so loud!” cautioned a voice.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Close that transom,” ordered someone, and\nthen Larry moved away, fearing the men might\ncome out, and find him listening. He wanted to\nknow more of the matter, for he felt sure some\nunderhanded game was afoot.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("That afternoon, on the way home, Larry told\nMr. Newton of what he had heard.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I’ll bet there’s some sort of a deal on,” said\nthe older reporter. “Glad you happened to overhear\nthat, Larry. I’ll get busy on the tip, and\nmaybe we can block the game.”")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_28",
      "title": "28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pg-boilerplate",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0